import React, { useState } from "react";
import { BtnClickSound } from "../element/audiofile";


const AlreadyLoginModel = (props) => {

    return (
        <>
        <div id="popupWin2" class="popupWin block">
        
            <div className="pop_text poptext2">
                
                <div className="fd m_t_10 clr_b9 text">
                Other Device login Detected With same Userid. Force login here press ok...
                </div>
                <div class="fd">
                    <button className="forcelogin_bt_1 m_t_20 okbtn" onClick={()=>{
                        BtnClickSound();
                        props.forceLogout(); props.setAlreadyLoginPopup(false); props.screenRoute("/lobby");}}>
                        Ok
                    </button>
                    <button className="forcelogin_bt_1 m_t_20 cancelbtn" onClick={()=>{props.setAlreadyLoginPopup(false)}}> Cancel</button>
                </div>
            </div>
            </div>
        </>
    )

}


export default AlreadyLoginModel;